import moment from 'moment'

export default {
  onShow () {
    this.show = true
  },
  afterCreated () {
    this.wasRaised = true
    this.show = true
  },
  afterUpdated () {
    this.beenUpdated = true
    this.show = true
  },
  prepareSearch (search) {
    const date = moment(search.agenda_name, 'DD/MM/YYYY')
    if (date.isValid() && date.format('DD/MM/YYYY') === search.agenda_name) {
      search.validity = date.format('YYYY-MM-DD')
      delete search.agenda_name
    }

    return search
  }
}



// WEBPACK FOOTER //
// ./src/app/professional/agenda/rules/index/resources/methods.js